import { FC, PropsWithChildren } from 'react';
import { Typography } from '@dagensmat/carrot/Components';

export const FormFieldFeedback: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Typography variant="paragraphSmall" color="secondary">
      {children}
    </Typography>
  );
};
